export default {
  years: "年",
  countries: "国家",
  leadership: "领导力",
  quality: "质量",
  solutions: "解决方案",
  facilities: "设施",
  approvals: "批准",
  customers: "客户",
  operations: "运营",
  focused: "专注",
  vision: "愿景",
};

